import { GridRenderEditCellParams, GridEditInputCell } from "@mui/x-data-grid";
import Tooltip from "@mui/material/Tooltip";
import theme from "theme";

function EmailInputCell(props: GridRenderEditCellParams) {
  const { error } = props;
  const { message } = props;
  const { ref } = props;
    return (
      <Tooltip open={error} title={message} componentsProps={{
        tooltip: {
          sx: {
            bgcolor: theme.palette.error.main,
            color: "white"
          }
        }
      }}>
        <div style={{height:'100%', width:'100%'}}>
        <GridEditInputCell ref={ref} {...props} sx={{minHeight:'100%'}} />
        </div>
      </Tooltip>
    );
}

export default EmailInputCell;